import { useLocation } from 'wouter'

// Routes where bottom tabs should be visible
const SHOW_TABS_ROUTES = [
  '/',
  '/events',
  '/account',
  '/order'
]

export function useNavigationTabs() {
  const [location] = useLocation()

  const isVisible = SHOW_TABS_ROUTES.some(route =>
    route === '/'
      ? location === '/'
      : location.startsWith(route)
  )

  return {
    isVisible,
    location
  }
}
